import token from "styled-token";
import { addSuffix } from "../util/addSuffix";
/** @mixin spaceMixin */

/**
 * Returns the spacing value.
 *
 * @example
 * import { spaceMixin } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *     margin-top: ${spaceMixin('sm')};
 *     margin-bottom: ${spaceMixin('sm', space => space.value * 2 + space.suffix)};
 * `;
 *
 * @method
 * @param {string|number} spacing - The spacing t-shirt size or number multiplier.
 * @param {function} [callback] - A callback that can be used to modify the resulting value.
 *    The callback receives an object with values `value` and `suffix`, where `value` is the numeric
 *    value of the spacing, and `suffix` is the value type (e.g. "px").
 * @return {Interpolation}
 */

export var spaceMixin = function spaceMixin(space, callback) {
  return token({
    gridBase: "gridBase",
    spacing: "spacing",
    suffix: "defaultUnit"
  }, function (_ref) {
    var gridBase = _ref.gridBase,
        spacing = _ref.spacing,
        suffix = _ref.suffix;
    var value = 0;

    if (spacing) {
      if (space in spacing) {
        value = spacing[space];
      } else {
        var multiplier = Number(space);

        if (isNaN(multiplier)) {
          multiplier = 0;
        }

        value = (gridBase || 0) * multiplier;
      }
    }

    if (typeof callback === "function") {
      return callback({
        value: value,
        suffix: suffix
      });
    }

    return addSuffix(value, suffix);
  });
};